import { Link } from 'react-router-dom';
import { ResourceItem } from '@/components/ui/ResourceItem';
import morningCenteringPhoto from '@/assets/morning-centering.jpg';
import breathingPracticePhoto from '@/assets/breathing-practice.jpg';

const audioResources = [
  {
    type: 'audio' as const,
    title: 'Morning Centering Practice',
    description: 'Start your day with mindful breathing and centering techniques',
    duration: '4 min',
    addedDate: '1 Week Ago',
    isFavorited: true,
    photo: morningCenteringPhoto
  },
  {
    type: 'audio' as const,
    title: 'Quick Reset Breathing',
    description: 'Two-minute breathing exercise to reset and refocus during busy days',
    duration: '2 min',
    addedDate: '1 Month Ago',
    photo: breathingPracticePhoto
  },
  {
    type: 'audio' as const,
    title: 'Confidence Anchor Practice',
    description: 'Build lasting confidence with this guided visualization practice',
    duration: '6 min',
    addedDate: '2 Months Ago'
  }
];

export const ResourcesAudioPage = () => (
  <div className="space-y-8 animate-fade-in">
    <div className="flex justify-between items-start">
      <h1 className="text-3xl font-semibold text-white font-literata mb-2">Audio Resources</h1>
      <div className="flex space-x-6">
        <Link to="/resources" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">All</Link>
        <Link to="/resources/pdf" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">PDF</Link>
        <Link to="/resources/audio" className="text-white border-b-2 border-bodhi-orange pb-1">Audio</Link>
        <Link to="/resources/favorites" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">Favorites</Link>
      </div>
    </div>
    <div className="overflow-x-auto pb-4">
      <div className="flex space-x-4 animate-fade-in">
        {audioResources.map((resource, index) => (
          <ResourceItem
            key={index}
            type={resource.type}
            title={resource.title}
            description={resource.description}
            duration={resource.duration}
            addedDate={resource.addedDate}
            isFavorited={resource.isFavorited}
            photo={resource.photo}
          />
        ))}
      </div>
    </div>
  </div>
);